import PubSub from "underpub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

var ContentFourUpIconItems = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ContentFourUpIconItems',
	};

	$.extend(true, this.options, options);

};

ContentFourUpIconItems.prototype.init = function() {

	var self = this;

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__iconItemIcon`) );

	this.slideCounterEq.equalizeHeights();

	$(window).on('load', function() {
		self.slideCounterEq.equalizeHeights();
	});

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
	});

	// gsap.to(self.options.$el.find(`.${self.options.baseClass}__iconItemHeading__line`), {
	// 	scrollTrigger: {
	// 		trigger: self.options.$el,
	// 		start: "bottom bottom",
	// 		end: "top top"
	// 	},
	// 	right: "0%",
	// 	duration: 1,
	// 	ease: "power1.out"
	// });

	gsap.to(self.options.$el.find(`.${self.options.baseClass}__iconItem`), {
		scrollTrigger: {
			trigger: self.options.$el.find(`.${self.options.baseClass}__iconItemsRow`),
			start: "top bottom-=25%",
			// markers: true,
		},
		y: 0,
		opacity: 1,
		duration: 0.8,
		ease: "power3.out",
		stagger: 0.165
	});


};

export default ContentFourUpIconItems;
